import { lazy } from 'react';

import Loadable from '../components/Loadable';
import MainLayout from '../layout/MainLayout';
const HomePage = Loadable(lazy(() => import('../pages/home/Home')));
const VideoPage = Loadable(lazy(() => import('../pages/video/Video')));
const ProfilePage = Loadable(lazy(() => import('../pages/profile/Profile')));
const WatchPage = Loadable(lazy(() => import('../pages/watch/Watch')));
const FindLinkPage = Loadable(lazy(() => import('pages/find/FindLink')));
const Subscription = Loadable(lazy(() => import('pages/subscription/subscription')));
const PaystackCallbackPage = Loadable(lazy(() => import('pages/payment/PaystackCallback')));

const SeoLandingPage = Loadable(lazy(() => import('../pages/seo/SeoLandingPage')));
const LegalDocumentPage = Loadable(lazy(() => import('../pages/seo/LegalDocumentPage')));
const NotFoundPage = Loadable(lazy(() => import('../pages/seo/NotFoundPage')));

const seoPages = require('../pages/seo/seoPages.json');
const pagesByPath = Object.fromEntries(seoPages.map((page) => [page.path, page]));

const seoRoutes = seoPages.map((page) => ({
    path: page.path.slice(1),
    element: page.document
        ? <LegalDocumentPage page={page} />
        : <SeoLandingPage page={page} pagesByPath={pagesByPath} />
}));

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '',
            element: <HomePage />
        },
        {
            path: 'video/:slug',
            element: <VideoPage />
        },
        {
            path: 'profile/:username',
            element: <ProfilePage />
        },
        {
            path: 'watch/:link',
            element: <WatchPage />
        },
        // {
        //     path: 'explore',
        //     element: (
        //         // <RequireSubscription>
        //         <ExplorePage />
        //         // </RequireSubscription>
        //     )
        // },
        {
            path: 'find_link',
            element: <FindLinkPage />
        },
        {
            path: '/subscription',
            element: <Subscription />
        },
        ...seoRoutes,
        {
            path: 'payment/callback',
            element: <PaystackCallbackPage />
        },
        {
            path: '*',
            element: <NotFoundPage />
        }
    ]
};

export default MainRoutes;
